<template>
    <div>
        <div v-if="approveAndPending.length>0">
            <GChart
                    type="ColumnChart"
                    :data="approveAndPending[0]"
                    :options="chartOptions"
            />
        </div>
        <div v-else>
            <div v-if="loading">
                <ChartPreLoader :typeChange="typeChange"></ChartPreLoader>
            </div>
            <div v-else>
                <EmptyChart></EmptyChart>
            </div>

        </div>

    </div>

</template>
<script>
    import ChartPreLoader from '@/views/charts/ChartPreLoader'
    import EmptyChart from '@/views/charts/EmptyChart'
    import { GChart } from 'vue-google-charts'
    export default {
        components: {
            GChart,
            ChartPreLoader,
            EmptyChart
        },
        props:['val','approveAndPending','loading'],
        data () {
            return {
                // Array will be automatically processed with visualization.arrayToDataTable function
                chartData: [
                    [
                        ['Ward', 'Approved','Pending'],
                        ['১নং ওয়ার্ড ', 0,0],
                        ['২নং ওয়ার্ড ', 0,0],
                        ['৩নং ওয়ার্ড ', 0,0],
                        ['৪নং ওয়ার্ড ', 0,0],
                        ['৫নং ওয়ার্ড ', 0,0],
                        ['৬নং ওয়ার্ড ', 0,0],
                        ['৭নং ওয়ার্ড ', 0,0],
                        ['৮নং ওয়ার্ড ', 0,0],
                        ['৯নং ওয়ার্ড ', 0,0],
                        ['১০নং ওয়ার্ড ', 0,0],
                        ['১১নং ওয়ার্ড ', 0,0],
                        ['১২নং ওয়ার্ড ', 0,0],
                    ],
                    [
                        ['Month', 'Approved','Pending'],
                        [' জানুয়ারি', 0,0],
                        ['ফেব্রুয়ারী ',  0,0],
                        ['মার্চ ', 0,0],
                        ['এপ্রিল ',  0,0],
                        ['মে ', 0,0],
                        ['জুন',  0,0],
                        ['জুলাই ', 0,0],
                        ['অগাস্ট ',  0,0],
                        ['সেপ্টেম্বর ',  0,0],
                        ['অক্টোবর ',  0,0],
                        ['নভেম্বর ', 0,0],
                        ['ডিসেম্বর ',  0,0],
                    ]

                ],
                chartOptions: {
                    "animation": { "duration": 3000, "easing": "out", "startup": true }
                },
                addLoader:true,
                typeChange:'bar-chart'
            }
        }
    }
</script>
<!--<script>-->
<!--import { Bar } from 'vue-chartjs'-->
<!--import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'-->

<!--export default {-->
<!--  extends: Bar,-->
<!--  mounted () {-->
<!--    // Overwriting base render method with actual data.-->
<!--    this.renderChart(-->
<!--      {-->
<!--        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],-->
<!--        datasets: [-->
<!--          {-->
<!--            label: 'GitHub Commits',-->
<!--            backgroundColor: '#f87979',-->
<!--            data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]-->
<!--          }-->
<!--        ]-->
<!--      },-->
<!--      {-->
<!--        responsive: true,-->
<!--        maintainAspectRatio: true,-->
<!--        tooltips: {-->
<!--          enabled: false,-->
<!--          custom: CustomTooltips,-->
<!--          intersect: true,-->
<!--          mode: 'index',-->
<!--          position: 'nearest',-->
<!--          callbacks: {-->
<!--            labelColor: function (tooltipItem, chart) {-->
<!--              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }-->
<!--            }-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    )-->
<!--  }-->
<!--}-->
<!--</script>-->
